/**
 * è®°å½æ¥å¿å·¥å·ç±»
 * å¯ç¨éå¨æ§å¶å°è¾å¥ï¼window.logcontext={info:true,error:true}
 */

interface Output {
  log(...message: any[]): void;
  error(...message: any[]): void;
}

class LogContext {
  info: boolean;
  error: boolean;
}

export class Logger {
  private LOG_CONTEXT_NAME = 'logcontext';
  private DEFUALT_LOGGER = new LogContext();

  public info(...param: any[]) {
    if (this.isInfoEnabled()) {
      const output = this.getOutput();
      output.log.apply(output, arguments);
    }
  }

  public error(...param: any[]) {
    if (this.isErrorEnabled()) {
      const output = this.getOutput();
      output.error.apply(output, arguments);
    }
  }

  private isInfoEnabled() {
    const context = this.getLogContext();
    return context.info;
  }

  private isErrorEnabled() {
    const context = this.getLogContext();
    return context.info || context.error;
  }

  private hasOutput(): boolean {
    return !!this.getOutput();
  }

  private getOutput(): Output {
    return console;
  }

  private getLogContext(): LogContext {
    if (window.top && window.top[this.LOG_CONTEXT_NAME]) {
      return window.top[this.LOG_CONTEXT_NAME];
    } else {
      return this.DEFUALT_LOGGER;
    }
  }
}

export class LogUtil {
  private static logger = new Logger();

  static info(...param: any[]) {
    LogUtil.logger.info.apply(LogUtil.logger, arguments);
  }

  static error(...param: any[]) {
    LogUtil.logger.error.apply(LogUtil.logger, arguments);
  }
}
